<template>
  <div class="mini-calendar__events" ref="events">
    <MiniCalenderSearch />
    <MiniCalenderPool />

    <ul class="mini-calendar__events-list" v-show="eventlist.length > 0">
      <li v-for="(item) in eventlist" :key="item.date_id" >
        <MiniCalenderEvent :event="item"/>
      </li>
    </ul>

    <div class="mini-calendar__events-no-result" v-show="eventlist.length == 0 && total >= 0">
      <p class="mini-calendar__events-no-result-text">Sorry, no events were found that matched your criteria. <a href="javascript:void(0);" class='mini-calendar__events-no-result-link' @click="showAllEvents">Show All Events</a></p>
    </div>

    <MiniCalenderPager :scroll="scrollTo"/>
  </div>
</template>

<script>
import MiniCalenderSearch from './mini-calendar-search.vue'
import MiniCalenderEvent from './mini-calendar-event.vue'
import MiniCalenderPool from './mini-calendar-pool.vue'
import MiniCalenderPager from "./mini-calendar-pager.vue"
import { getEvents } from './../api'
import { mapGetters, mapActions } from 'vuex'


export default {
  name: 'MiniCalenderEvents',
  components: {
    MiniCalenderSearch,
    MiniCalenderEvent,
    MiniCalenderPool,
    MiniCalenderPager
  },
  computed: {
    ...mapGetters(['eventlist', 'date_range', 'total'])
  },
  methods: {
    showAllEvents() {
      this.setLoading(true);

      getEvents().then((eventlist) => {
        this.setEventList({eventlist: eventlist.data, total: eventlist.query.total});
        this.setClearAll();
        this.setFilter([]);
        this.$router.push("/");
        this.setLoading(false);
      }).catch(() => {
        this.setLoading(false);
      });
    },
    scrollTo() {
      this.$refs.events.scrollIntoView();
    },
    ...mapActions(['setEventList', 'setClearAll', 'setLoading', 'setMonthEvents', 'setCategoryList', 'setFilter'])
  }
}
</script>
<style lang="scss">
  .mini-calendar__events {
    padding-right: rem(30);
    padding-left: rem(30);

    @include tablet-up {
      flex: 0 1 auto;
      width: 60%;
    }

    @include desktop-xl-up {
      width: 70%;
      padding-left: 0;
    }

    &-list {
      list-style: none;
      margin: 0;
      padding: 0;
      border-top: 1px solid $border-color2;

      > li {
        list-style: none;
        margin: 0;
        padding: rem(30) 0;
        border-bottom: 1px solid $border-color2;

        &::before {
          display: none;
        }
      }
    }

    &-no-result {

      &-text {
        color: $text-color;
      }

      &-link {
        color: $text-color1;

        &:hover {
          color: $alert-color;
        }
      }
    }
  }
</style>